module.exports = __webpack_public_path__ + "static/media/hui_yu_chien.04de7317.jpg";